import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FcpAccordionComponent } from './fcp-accordion.component';
import { FcpAccordionItemComponent } from './fcp-accordion-item.component';
import { FcpIconModule } from '../fcp-icon';

@NgModule({
    declarations: [FcpAccordionComponent, FcpAccordionItemComponent],
    imports: [CommonModule, FcpIconModule],
    exports: [FcpAccordionComponent, FcpAccordionItemComponent]
})
export class FcpAccordionModule {}
